var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.attachmentList.length > 0 ? _c('div', {
    staticClass: "book_relation"
  }, [_c('WTitle', {
    staticClass: "type4",
    attrs: {
      "tag-name": "h4"
    }
  }, [_vm._v("활동 자료 " + _vm._s(_vm.attachmentList.length))]), _c('ul', {
    staticClass: "book_relation_list"
  }, _vm._l(_vm.attachmentList, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "book_relation_item"
    }, [_c('a', {
      staticClass: "btn_size1 btn_primary_outline",
      attrs: {
        "href": _vm.isVideoType(item.attachmentType) ? item.urlLink : item.filePath,
        "title": item.text,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "btn_text"
    }, [_vm._v(_vm._s(item.text))])])]);
  }), 0)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }